<template>
  <VApp id="inspire">
    <VContent>
      <VContainer
        fluid
        fill-height
      >
        <VLayout
          align-center
          justify-center
        >
          <VFlex
            md4
            sm8
            xs12
          >
            <LoginCard />
          </VFlex>
        </VLayout>
      </VContainer>
    </VContent>
  </VApp>
</template>

<script>
import LoginCard from '@/components/LoginCard'
export default {
  name: 'LoginPage',
  components: {
    LoginCard
  }
}
</script>
